module.exports = "<div class=\"col-xs-4\">\r\n<h3>\r\n    Liste der Benutzer\r\n</h3>\r\n<app-table-template *ngIf=\"users && columns\" [data]=\"users\" [columns]=\"columns\"></app-table-template><br>\r\n<button class=\"btn btn-success\" *ngIf=\"userService.user && userService.user.userType === userService.Admin\" [routerLink]=\"['/user/new', 0]\">\r\n            Neuen Benutzer anlegen\r\n</button>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/userList/user.list.component.html
// module id = 277
// module chunks = 1